import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Download, Captions, CheckCircle2, XCircle } from "lucide-react";
import { api, API } from "../../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { Progress } from "../ui/progress";
import { Button } from "../ui/button";

export const RenderDialog = ({ jobId, onClose }) => {
  const [v, setV] = useState(null);
  const nav = useNavigate();

  useEffect(() => {
    if (!jobId) return;
    setV(null);
    let stop = false;
    const tick = async () => {
      try {
        const { data } = await api.get(`/videos/${jobId}`);
        setV(data);
        if (!stop && !["done", "failed"].includes(data.status)) setTimeout(tick, 2000);
      } catch { if (!stop) setTimeout(tick, 3000); }
    };
    tick();
    return () => { stop = true; };
  }, [jobId]);

  const vertical = v?.aspect === "9:16";
  return (
    <Dialog open={!!jobId} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-zinc-950 border-white/10 max-w-2xl" data-testid="render-dialog">
        <DialogHeader><DialogTitle className="text-white">{v?.status === "done" ? "¡Video listo!" : v?.status === "failed" ? "Error en el render" : "Renderizando tu video"}</DialogTitle></DialogHeader>
        {v?.status === "done" ? (
          <div className="space-y-4">
            <video data-testid="render-result-video" src={`${API}/videos/${v.id}/file`} controls autoPlay
              className={`mx-auto rounded-xl border border-white/10 bg-black ${vertical ? "h-[60vh]" : "w-full"}`} />
            <div className="flex flex-wrap gap-3 items-center">
              <a href={`${API}/videos/${v.id}/file?download=1`} data-testid="render-download-mp4"><Button className="rounded-full bg-[#E8C47C] hover:bg-[#F3D9A4] text-black font-semibold"><Download className="h-4 w-4 mr-2" />Descargar MP4</Button></a>
              {v.has_srt && <a href={`${API}/videos/${v.id}/srt`} data-testid="render-download-srt"><Button variant="outline" className="rounded-full border-white/10"><Captions className="h-4 w-4 mr-2" />SRT</Button></a>}
              <span className="text-xs font-mono-tc text-zinc-500 ml-auto">{v.duration}s · {v.width}x{v.height} · {v.size_mb} MB</span>
            </div>
          </div>
        ) : v?.status === "failed" ? (
          <div className="flex gap-3 text-sm text-red-300" data-testid="render-error"><XCircle className="h-5 w-5 shrink-0" />{v.error}</div>
        ) : (
          <div className="space-y-4 py-4">
            <Progress value={v?.progress || 2} data-testid="render-progress" className="h-2" />
            <div className="flex justify-between text-sm"><span className="text-zinc-300" data-testid="render-step">{v?.step || "En cola"}</span><span className="font-mono-tc text-[#E8C47C]">{v?.progress || 0}%</span></div>
            <p className="text-xs text-zinc-500">Puedes cerrar esta ventana; el render continúa y aparecerá en "Mis videos".</p>
          </div>
        )}
        {v?.status === "done" && <Button variant="ghost" onClick={() => nav("/videos")} data-testid="render-go-videos" className="text-zinc-400"><CheckCircle2 className="h-4 w-4 mr-2" />Ver todos mis videos</Button>}
      </DialogContent>
    </Dialog>
  );
};
